import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'unicon-accordion-card',
  templateUrl: './accordion-card.component.html',
})
export class AccordionCardComponent implements AfterViewInit {
  @ViewChild('toggleElement') element!: ElementRef<HTMLDivElement>;
  @ViewChild('toggleButton') openner!: ElementRef<HTMLButtonElement>;
  @Input() title: string = '';
  protected opened: boolean = true;
  private observer!: MutationObserver;

  ngAfterViewInit(): void {
    this.setAnimations();
    this.observeToggleElement();
  }

  private observeToggleElement(): void {
    this.observer = new MutationObserver(() => {
      this.setAccordionHeight();
    });
    this.observer.observe(this.element.nativeElement, {
      childList: true,
      subtree: true,
    });
  }

  private setAnimations(): void {
    this.element.nativeElement.style.transition = 'max-height 0.4s ease-in-out';
    this.openner.nativeElement.style.transition = '0.4s';
  }

  protected toggle(): void {
    this.opened = !this.opened;
    const element: HTMLDivElement = this.element.nativeElement;
    const chevron: HTMLButtonElement = this.openner.nativeElement;

    if (this.opened) {
      element.style.maxHeight = `${element.scrollHeight}px`;
      chevron.style.transform = 'rotate(0deg)';
    } else {
      element.style.maxHeight = `0`;
      chevron.style.transform = 'rotate(180deg)';
    }
  }

  private setAccordionHeight(): void {
    const element: HTMLDivElement = this.element.nativeElement;
    element.style.maxHeight = `${this.opened ? element.scrollHeight : 0}px`;
  }
}
